import { render, staticRenderFns } from "./GoogleSlidesContentTab.vue?vue&type=template&id=5635e6f1&scoped=true&"
import script from "./GoogleSlidesContentTab.vue?vue&type=script&lang=js&"
export * from "./GoogleSlidesContentTab.vue?vue&type=script&lang=js&"
import style0 from "./GoogleSlidesContentTab.vue?vue&type=style&index=0&id=5635e6f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5635e6f1",
  null
  
)

export default component.exports